import React from "react";

const UsersProtacols = () => {
  return <div>UsersProtacols</div>;
};

export default UsersProtacols;
